export default {"src":"/_next/static/media/icon_circle_x.960ec4bb.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};